import { createStore } from "redux";

import { Action as StoreCurrentInvestmentAction, STORE_CURRENT_CREATED_INVESTMENT_ACTION, STORE_CURRENT_INVESTMENT_ACTION, STORE_INVESTMENTS_ACTION, STORE_UPDATE_INVESTMENT_ACTION } from "./investment/actions";
import { storeCurrentCreatedInvestmentReducer, storeCurrentInvestmentReducer, storeInvestmentsReducer, storeUpdateInvestmentReducer } from "./investment/reducers";
import { Action as SaleAction, STORE_SALES_ACTION } from "./sale/actions";
import { storeSalesReducer } from "./sale/reducers";
import { initialState, StoreState } from "./types";
import {
  Action as UserAction,
  LANGUAGE_ACTION,
  LOGIN_ACTION,
  LOGOUT_ACTION,
  STORE_CURRENT_USER_ACTION,
} from "./user/actions";
import {
  languageReducer,
  loginReducer,
  logoutReducer,
  storeCurrentUserReducer,
} from "./user/reducers";

type Action = SaleAction | UserAction | StoreCurrentInvestmentAction;

const reducer = (
  state: StoreState | undefined,
  action: Action,
): StoreState => {
  const usedState = state ? state : initialState;

  switch (action.type) {
    case LANGUAGE_ACTION:
      return languageReducer(
        usedState,
        action.payload,
      );
    case LOGIN_ACTION:
      return loginReducer(
        usedState,
        action.payload.token
      );
    case LOGOUT_ACTION:
      return logoutReducer(usedState);
    case STORE_CURRENT_USER_ACTION:
      return storeCurrentUserReducer(
        usedState,
        action.payload
      );
    case STORE_CURRENT_CREATED_INVESTMENT_ACTION:
      return storeCurrentCreatedInvestmentReducer(
        usedState,
        action.payload
      );
    case STORE_CURRENT_INVESTMENT_ACTION:
      return storeCurrentInvestmentReducer(
        usedState,
        action.payload.currentInvestment
      );
    case STORE_INVESTMENTS_ACTION:
      return storeInvestmentsReducer(
        usedState,
        action.payload.investments
      );
    case STORE_SALES_ACTION:
      return storeSalesReducer(
        usedState,
        action.payload.sales
      );
    case STORE_UPDATE_INVESTMENT_ACTION:
      return storeUpdateInvestmentReducer(
        usedState,
        action.payload
      );
    default:
      return usedState;
  }
};

const windowDev = window as any;
// Need this line of code to use ReduxDevTool plugin
const reduxDevTools = (windowDev.__REDUX_DEVTOOLS_EXTENSION__ &&
  windowDev.__REDUX_DEVTOOLS_EXTENSION__()) as any;

export const RootStore = createStore(
  reducer,
  initialState,
  reduxDevTools
);
